import { render, staticRenderFns } from "./order-data.vue?vue&type=template&id=4d534be3&scoped=true&"
import script from "./order-data.vue?vue&type=script&lang=js&"
export * from "./order-data.vue?vue&type=script&lang=js&"
import style0 from "./order-data.vue?vue&type=style&index=0&id=4d534be3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d534be3",
  null
  
)

export default component.exports